<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_6 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<v-sheet
			rounded
			color="primary"
			class="my-5 px-4 mt-10 text-h6"
		>
				<span class="tertiary--text">
					Dati Contratto di Servizio
				</span>
		</v-sheet>
		
		<template v-if="pratica.contratto_di_servizio_id === null">
			Contratto di Servizio non ancora caricato
		</template>
		
		<template v-else>
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('nome')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.nome"
							@input="pratica.contratto_di_servizio.nome = $event !== '' ? $event : null"
							label="Nome"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('cognome')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.cognome"
							@input="pratica.contratto_di_servizio.cognome = $event !== '' ? $event : null"
							label="Cognome"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
			
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('ragione_sociale')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.ragione_sociale"
							@input="pratica.contratto_di_servizio.ragione_sociale = $event !== '' ? $event : null"
							label="Ragione Sociale"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('partita_iva')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.partita_iva"
							@input="pratica.contratto_di_servizio.partita_iva = $event !== '' ? $event : null"
							label="P.IVA (o, in assenza, codice fiscale)"
							outlined
							dense
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
							:rules="[validaPartitaIvaCodiceFiscaleAziendaleOPersonale]"
						></v-text-field>
					</v-badge>
				</v-col>
			
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('indirizzo_fatturazione')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.indirizzo_fatturazione"
							@input="pratica.contratto_di_servizio.indirizzo_fatturazione = $event !== '' ? $event : null"
							label="Indirizzo di Fatturazione"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('comune_fatturazione')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-autocomplete
							:value="pratica.contratto_di_servizio.comune_fatturazione"
							@input="pratica.contratto_di_servizio.comune_fatturazione = $event ? $event.comune : null"
							label="Comune di Fatturazione"
							:items="comuni"
							item-value="comune"
							item-text="comune"
							return-object
							:filter="(item, queryText, itemText) => customFilterByProperties(item, queryText, ['comune', 'sigla'])"
							:search-input.sync="cercaComune"
							@change="gestisciAutoCompletamentoPartendoDalComune($event)"
							:loading="isLoadingComuni"
							:disabled="isLoading"
							:readonly="action == 'show' || !isAccountManager"
							:no-data-text="isLoadingComuni ? 'In caricamento..' : (cercaComune == null || cercaComune.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Comune non trovato')"
							:persistent-placeholder="isCliente"
							clearable
							hide-details
							autocomplete="none"
							outlined
							dense
						>
							<template v-slot:item="data">
								{{ data.item.comune }} ({{data.item.sigla}})
							</template>
							<template v-slot:selection="data">
								{{ data.item.comune }}
							</template>
						</v-autocomplete>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('cap_fatturazione')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-select
							v-if="isAccountManager"
							v-show="selezioneCapInCorso"
							ref="caps"
							:value="pratica.contratto_di_servizio.cap_fatturazione"
							@input="pratica.contratto_di_servizio.cap_fatturazione = $event !== '' ? $event : null"
							item-text="codice"
							item-value="codice"
							:items="capsItems"
							label="Seleziona un CAP"
							:readonly="action == 'show'"
							outlined
							dense
							hide-details
						></v-select>
						<v-text-field
							v-show="!selezioneCapInCorso"
							:value="pratica.contratto_di_servizio.cap_fatturazione"
							@input="pratica.contratto_di_servizio.cap_fatturazione = $event !== '' ? $event : null"
							label="CAP di Fatturazione"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:loading="isLoadingAllByComuneId"
							:disabled="isLoading || isLoadingAllByComuneId"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('provincia_fatturazione')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.provincia_fatturazione"
							@input="pratica.contratto_di_servizio.provincia_fatturazione = $event !== '' ? $event : null"
							label="Provincia di Fatturazione"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:loading="isLoadingAllByComuneId"
							:disabled="isLoading || isLoadingAllByComuneId"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
			
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('nazione_fatturazione')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.nazione_fatturazione"
							@input="pratica.contratto_di_servizio.nazione_fatturazione = $event !== '' ? $event : null"
							label="Nazione di Fatturazione"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:loading="isLoadingAllByComuneId"
							:disabled="isLoading || isLoadingAllByComuneId"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('telefono')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.telefono"
							@input="pratica.contratto_di_servizio.telefono = $event !== '' ? $event : null"
							label="Telefono"
							outlined
							dense
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
							:rules="[mixin_rules.telefono]"
						></v-text-field>
					</v-badge>
				</v-col>
			
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('pec')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.pec"
							@input="pratica.contratto_di_servizio.pec = $event !== '' ? $event : null"
							label="PEC"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
							:rules="[mixin_rules.email]"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('codice_univoco')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-autocomplete
							:value="pratica.contratto_di_servizio.codice_univoco"
							@input="pratica.contratto_di_servizio.codice_univoco = $event !== '' ? $event : null"
							label="Codice Univoco SDI"
							:items="codiciSDI"
							:loading="isLoadingCodiciSDI"
							:disabled="isLoadingCodiciSDI"
							:search-input.sync="searchCodiceUnivoco"
							:persistent-placeholder="isCliente"
							:readonly="action == 'show' || !isAccountManager"
							autocomplete="none"
							clearable
							dense
							outlined
							hide-details
						>
							<template v-slot:append v-if="isAccountManager">
								<v-icon
									color="primary"
									@click="openAggiungiCodiceSDIDialog"
									class="cursor-pointer"
								>
									mdi-plus
								</v-icon>
							</template>
						</v-autocomplete>
					</v-badge>
				</v-col>
			
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('email')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.email"
							@input="pratica.contratto_di_servizio.email = $event !== '' ? $event : null"
							label="Email"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							autocomplete="none"
							:rules="[mixin_rules.email]"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('numero_domande')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.numero_domande"
							@input="pratica.contratto_di_servizio.numero_domande = $event !== '' ? parseInt($event) : null"
							label="Numero Domande"
							type="number"
							min="0"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:rules="[mixin_rules.min0]"
							:persistent-placeholder="isCliente"
							autocomplete="none"
						></v-text-field>
					</v-badge>
				</v-col>
				
				<!--<v-col cols="6">-->
				<!--	<v-badge-->
				<!--		:value="contrattoDiServizioDiff.includes('tipo')"-->
				<!--		class="d-block"-->
				<!--		color="info"-->
				<!--		overlap-->
				<!--		right-->
				<!--		icon="mdi-pencil"-->
				<!--	>-->
				<!--		<v-select-->
				<!--			:items="tipiContrattoDiServizioOld"-->
				<!--			v-model="pratica.contratto_di_servizio.tipo"-->
				<!--			label="Tipo"-->
				<!--			outlined-->
				<!--			dense-->
				<!--			hide-details-->
				<!--			clearable-->
				<!--			:readonly="action == 'show' || !isAccountManager"-->
				<!--			:disabled="isLoading"-->
				<!--			:persistent-placeholder="isCliente"-->
				<!--		></v-select>-->
				<!--	</v-badge>-->
				<!--</v-col>-->
				
				<v-col cols="12">
					<v-badge
						:value="contrattoDiServizioDiff.includes('tipo_contratto_di_servizio_id')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-select
							:items="tipiContrattoDiServizio"
							item-text="nome"
							item-value="id"
							v-model="pratica.contratto_di_servizio.tipo_contratto_di_servizio_id"
							@change="aggiornaTipoPagamento($event)"
							label="Tipo di Contratto di Servizio"
							outlined
							dense
							hide-details
							clearable
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:loading="isLoadingTipiContrattoDiServizio"
							:persistent-placeholder="isCliente"
							return-object
						></v-select>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-text-field
						:value="pratica.contratto_di_servizio?.tipo_contratto_di_servizio?.tipo_pagamento"
						label="Modalità di Pagamento"
						outlined
						dense
						hide-details
						readonly
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-col>
				
				<v-col
					v-if="isAccountManager"
					cols="6"
				>
					<v-badge
						:value="contrattoDiServizioDiff.includes('tipo_erogazione_bonus')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-select
							v-model="pratica.contratto_di_servizio.tipo_erogazione_bonus"
							label="Modalità di Erogazione Bonus"
							:items="tipiErogazioneBonus"
							outlined
							dense
							hide-details
							:readonly="action == 'show'"
							:disabled="isLoading"
						></v-select>
					</v-badge>
				</v-col>
				
				<v-col cols="6" v-if="isAccountManager">
					<v-text-field
						:value="pratica.accordo.importo_totale_bonus_esiti_definitivi"
						label="Imponibile Totale Bonus"
						outlined
						dense
						hide-details
						readonly
						type="number"
					></v-text-field>
				</v-col>
			
				<!--<v-col-->
				<!--	v-if="!isCliente"-->
				<!--	class="d-flex align-center"-->
				<!--	cols="6"-->
				<!--&gt;-->
				<!--	<div class="mr-3">-->
				<!--		Gold-->
				<!--	</div>-->
				<!--	<v-badge-->
				<!--		:value="contrattoDiServizioDiff.includes('is_gold')"-->
				<!--		class="d-block"-->
				<!--		color="info"-->
				<!--		overlap-->
				<!--		right-->
				<!--		icon="mdi-pencil"-->
				<!--	>-->
				<!--		<v-radio-group-->
				<!--			v-model="pratica.contratto_di_servizio.is_gold"-->
				<!--			class="mt-0"-->
				<!--			row-->
				<!--			hide-details-->
				<!--			:disabled="isLoading"-->
				<!--			:readonly="action == 'show' || !isAccountManager"-->
				<!--		>-->
				<!--			<v-radio-->
				<!--				label="Si"-->
				<!--				:value="true"-->
				<!--			></v-radio>-->
				<!--			<v-radio-->
				<!--				label="No"-->
				<!--				:value="false"-->
				<!--			></v-radio>-->
				<!--		</v-radio-group>-->
				<!--	</v-badge>-->
				<!--</v-col>-->
				
			</v-row>
			
			<template v-if="isAccountManager">
				<v-sheet
					rounded
					color="primary"
					class="my-5 px-4 mt-10 text-h6"
				>
					<span class="tertiary--text">
						Creditsafe
					</span>
				</v-sheet>
				
				<template v-if="pratica.contratto_di_servizio_id === null">
					Contratto di Servizio non ancora caricato
				</template>
				
				<template v-else>
					<v-row>
						<v-col>
							<v-badge
								:value="contrattoDiServizioDiff.includes('punteggio_di_rischio')"
								class="d-block"
								color="info"
								overlap
								right
								icon="mdi-pencil"
							>
								<v-text-field
									:value="pratica.contratto_di_servizio.punteggio_di_rischio"
									@input="pratica.contratto_di_servizio.punteggio_di_rischio = $event !== '' ? $event : null"
									label="Punteggio di Rischio"
									outlined
									dense
									hide-details
									:readonly="action == 'show'"
									:disabled="isLoading"
								></v-text-field>
							</v-badge>
						</v-col>
						<v-col>
							<v-badge
								:value="contrattoDiServizioDiff.includes('score_internazionale')"
								class="d-block"
								color="info"
								overlap
								right
								icon="mdi-pencil"
							>
								<v-text-field
									:value="pratica.contratto_di_servizio.score_internazionale"
									@input="pratica.contratto_di_servizio.score_internazionale = $event !== '' ? $event : null"
									label="Score Internazionale"
									outlined
									dense
									hide-details
									:readonly="action == 'show'"
									:disabled="isLoading"
								></v-text-field>
							</v-badge>
						</v-col>
					</v-row>
					
					<v-row>
						<v-col>
							<template v-if="action == 'store' || action == 'edit'">
								<v-badge
									:value="haveFilesBeenModified.report"
									class="d-block"
									color="info"
									overlap
									right
									icon="mdi-pencil"
								>
									<v-file-input
										v-model="files.report"
										label="Report"
										hide-details
										outlined
										dense
										clearable
										accept=".pdf"
										truncate-length="120"
										@change="setFileChanged(files.report)"
										@click:clear="pratica.contratto_di_servizio.path_report = null"
										:loading="isLoadingReport"
										:disabled="isLoading"
									>
										<template v-slot:append>
											<template v-if="pratica.contratto_di_servizio.path_report !== null && !isLoadingReport">
												<v-progress-circular
													v-if="downloadingReport"
													size="24"
													width="3"
													color="primary"
													indeterminate
												></v-progress-circular>
												<v-icon
													v-else
													class="ml-3"
													@click="download(pratica.contratto_di_servizio.path_report, 'report')"
												>
													mdi-tray-arrow-down
												</v-icon>
											</template>
											<v-icon
												v-if="files.report !== null"
												class="ml-3"
												@click="viewFileInBrowser(files.report)"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</v-file-input>
								</v-badge>
							</template>
							<template v-else-if="action == 'show'">
								<v-text-field
									:value="getFileNameFromPath(pratica.contratto_di_servizio.path_report)"
									label="Modulo Codice Click Day"
									hide-details
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="pratica.contratto_di_servizio.path_report !== null"
									>
										<template>
											<v-progress-circular
												v-if="downloadingReport"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(pratica.contratto_di_servizio.path_report, 'report')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										<template>
											<v-progress-circular
												v-if="isGettingFile.report"
												size="24"
												width="3"
												color="primary"
												indeterminate
												class="ml-3"
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="getFileAndViewInBrowser(pratica.contratto_di_servizio.path_report, 'report')"
											>
												mdi-eye-outline
											</v-icon>
										</template>
									</template>
								</v-text-field>
							</template>
						</v-col>
					</v-row>
				</template>
			</template>
			
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Fatturazione
				</span>
			</v-sheet>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('data_scadenza_saldo_esiti_definitivi')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-menu
							v-model="menuDataScadenzaSaldoEsitiDefinitivi"
							:close-on-content-click="false"
							max-width="290"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:value="formatDateToItaly(pratica.contratto_di_servizio.data_scadenza_saldo_esiti_definitivi)"
									label="Data di Scadenza Fattura"
									outlined
									dense
									hide-details
									readonly
									:disabled="isLoading"
									:clearable="isAccountManager"
									v-bind="attrs"
									v-on="isAccountManager ? on : null"
									@click:clear="pratica.contratto_di_servizio.data_scadenza_saldo_esiti_definitivi = null"
									:persistent-placeholder="isCliente"
								></v-text-field>
							</template>
							<v-date-picker
								:value="pratica.contratto_di_servizio.data_scadenza_saldo_esiti_definitivi"
								@input="pratica.contratto_di_servizio.data_scadenza_saldo_esiti_definitivi = $event !== '' ? $event : null"
								@change="menuDataScadenzaSaldoEsitiDefinitivi = false"
								:readonly="action == 'show' || !isAccountManager"
								first-day-of-week="1"
							></v-date-picker>
						</v-menu>
					</v-badge>
				</v-col>
				
				<v-col cols="6">
					<v-badge
						:value="contrattoDiServizioDiff.includes('importo_saldo_esiti_definitivi')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.contratto_di_servizio.importo_saldo_esiti_definitivi"
							@input="pratica.contratto_di_servizio.importo_saldo_esiti_definitivi = $event !== '' ? $event : null"
							label="Imponibile Fattura"
							outlined
							dense
							hide-details
							readonly
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					<template v-if="action == 'store' || (action == 'edit' && isAccountManager)">
						<v-badge
							:value="haveFilesBeenModified.fattura_saldo_esiti_definitivi"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.fattura_saldo_esiti_definitivi"
								label="Fattura"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setChanged(files.fattura_saldo_esiti_definitivi)"
								@click:clear="pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi = null"
								:loading="isLoadingFatturaSaldoEsitiDefinitivi"
								:disabled="isLoading"
							>
								<template v-slot:append>
									<template v-if="pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi !== null && !isLoadingFatturaSaldoEsitiDefinitivi">
										<v-progress-circular
											v-if="downloadingFatturaSaldoEsitiDefinitivi"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi, 'fattura_saldo_esiti_definitivi')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
									<v-icon
										v-if="files.fattura_saldo_esiti_definitivi !== null"
										class="ml-3"
										@click="viewFileInBrowser(files.fattura_saldo_esiti_definitivi)"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					
					<template v-else-if="action == 'show' || isCliente">
						<v-text-field
							:value="getFileNameFromPath(pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi)"
							label="Fattura Esiti Definitivi"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi !== null"
							>
								<template>
									<v-progress-circular
										v-if="downloadingFatturaSaldoEsitiDefinitivi"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi, 'fattura_saldo_esiti_definitivi')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<template>
									<v-progress-circular
										v-if="isGettingFile.fattura_saldo_esiti_definitivi"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi, 'fattura_saldo_esiti_definitivi')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
		</template>
		
		<v-dialog
			v-model="aggiungiCodiceSDIDialog"
			:key="aggiungiCodiceSDIKey"
			persistent
			max-width="600"
			scrollable
		>
			<aggiungi-codice-sdi
				@close="aggiungiCodiceSDIDialog = false"
				@codice-sdi-aggiunto="handleCodiceSDIAggiunto($event)"
			></aggiungi-codice-sdi>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import vuetify from "../../../plugins/vuetify";
import axios from "axios";
// https://github.com/mattickx/jsvat-next
import { checkVAT, countries } from "jsvat-next";
// https://github.com/lucavandro/CodiceFiscaleJS?tab=readme-ov-file
const CodiceFiscale = require('codice-fiscale-js');
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'contrattoDiServizioDiff', 'haveFilesBeenModified'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_6: null,
				ci_sono_aggiornamenti_fase_6: false,
				ragione_sociale: null,
				partita_iva: null,
				indirizzo_fatturazione: null,
				data_di_nascita: null,
				luogo_di_nascita: null,
				pec: null,
				codice_univoco: null,
				data_scadenza_saldo: null,
				importo_saldo: null,
				data_scadenza_saldo_esiti_definitivi: null,
				importo_saldo_esiti_definitivi: null,
				contratto_di_servizio: {
					id: null,
					path_fattura_saldo: null,
					path_fattura_saldo_esiti_definitivi: null
				},
				accordo: {
					importo_totale_bonus_esiti_provvisori: null,
					importo_totale_bonus_esiti_definitivi: null
				}
			},
			
			isLoadingCodiciSDI: false,
			codiciSDI: [],
			searchCodiceUnivoco: '',
			
			menuDataDiNascita: false,
			menuDataScadenzaSaldo: false,
			menuDataScadenzaSaldoEsitiDefinitivi: false,
			
			files: {
				fattura_saldo: null,
				fattura_saldo_esiti_definitivi: null,
				report: null
			},
			
			isLoadingFatturaSaldo: false,
			downloadingFatturaSaldo: false,
			isLoadingFatturaSaldoEsitiDefinitivi: false,
			downloadingFatturaSaldoEsitiDefinitivi: false,
			isLoadingReport: false,
			downloadingReport: false,
			
			getComuniTimeout: null,
			comuni: [],
			isLoadingComuni: false,
			cercaComune: null,
			capsItems: [],
			selezioneCapInCorso: false,
			isLoadingAllByComuneId: false,
			
			aggiungiCodiceSDIDialog: false,
			aggiungiCodiceSDIKey: 0
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		if (this.pratica.ci_sono_aggiornamenti_fase_6  && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_6 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_6',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_6');
		}
		
		if (this.pratica.contratto_di_servizio.path_fattura_saldo !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getFatturaSaldo();
		}
		
		if (this.pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getFatturaSaldoEsitiDefinitivi();
		}
		
		if (this.pratica.contratto_di_servizio.path_report !== null && this.action != 'show' && this.isAccountManager) {
			this.getReport();
		}
		
		this.getCodiciSDI();
		
		if (this.pratica.contratto_di_servizio.comune_fatturazione !== null) {
			this.getComuni(this.pratica.contratto_di_servizio.comune_fatturazione);
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			tipiContrattoDiServizio: 'contrattoDiServizio/tipiContrattoDiServizio',
			isLoadingTipiContrattoDiServizio: 'contrattoDiServizio/isLoadingTipiContrattoDiServizio'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingFatturaSaldo
				|| this.isLoadingFatturaSaldoEsitiDefinitivi
				|| this.isLoadingTipiContrattoDiServizio
				|| this.isLoadingCodiciSDI;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
		'cercaComune': function (newVal) {
			clearTimeout(this.getComuniTimeout);
			this.getComuniTimeout = setTimeout(function () {
				if (newVal != null && newVal.length >= 2) this.getComuni(newVal);
			}.bind(this), 500);
			
		},
		'pratica.contratto_di_servizio.comune_fatturazione': function (newVal) {
			if (newVal === null) {
				this.selezioneCapInCorso = false;
			}
		},
	},
	
	methods: {
		vuetify() {
			return vuetify
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		async getFatturaSaldo() {
			this.isLoadingFatturaSaldo = true;
			this.files.fattura_saldo = await this.getFile(this.pratica.contratto_di_servizio.path_fattura_saldo);
			this.files.fattura_saldo.changed = false;
			this.isLoadingFatturaSaldo = false;
		},
		async getFatturaSaldoEsitiDefinitivi() {
			this.isLoadingFatturaSaldoEsitiDefinitivi = true;
			this.files.fattura_saldo_esiti_definitivi = await this.getFile(this.pratica.contratto_di_servizio.path_fattura_saldo_esiti_definitivi);
			this.files.fattura_saldo_esiti_definitivi.changed = false;
			this.isLoadingFatturaSaldoEsitiDefinitivi = false;
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'fattura_saldo') this.downloadingFatturaSaldo = true;
			else if (key == 'fattura_saldo_esiti_definitivi') this.downloadingFatturaSaldoEsitiDefinitivi = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'fattura_saldo') this.downloadingFatturaSaldo = false;
					else if (key == 'fattura_saldo_esiti_definitivi') this.downloadingFatturaSaldoEsitiDefinitivi = false;
				})
		},
		getComuni(toSearch = null) {
			this.isLoadingComuni = true;
			this.comuni = [];
			
			let params = {};
			if (toSearch != null) params.search = toSearch;
			
			axios.get('/api/comuni', {
				params: params
			})
				.then(response => {
					this.comuni = response.data.map(comune => {
						return {
							comune: comune.nome,
							sigla: comune.sigla,
							id: comune.id
						}
					});
				})
				.finally(() => {
					this.isLoadingComuni = false;
				});
		},
		gestisciAutoCompletamentoPartendoDalComune(comuneObj) {
			if (comuneObj !== null) {
				this.getAllByComuneId(comuneObj.id);
			}
			else {
				this.pratica.contratto_di_servizio.cap_fatturazione = null;
				this.pratica.contratto_di_servizio.provincia_fatturazione = null;
				this.pratica.contratto_di_servizio.sigla_provincia_fatturazione = null;
				this.pratica.contratto_di_servizio.nazione_fatturazione = null;
			}
			
		},
		getAllByComuneId(comuneId) {
			this.isLoadingAllByComuneId = true;
			this.selezioneCapInCorso = false;
			
			axios.get('/api/all-by-comune-id', {
				params: {
					comune_id: comuneId
				}
			})
				.then(response => {
					this.pratica.contratto_di_servizio.provincia_fatturazione = response.data.provincia.nome;
					this.pratica.contratto_di_servizio.sigla_provincia_fatturazione = response.data.provincia.sigla;
					this.pratica.contratto_di_servizio.nazione_fatturazione = response.data.provincia.regione.nazione.nome;
					
					this.capsItems = response.data.caps;
					
					if (this.capsItems.length == 1) {
						this.pratica.contratto_di_servizio.cap_fatturazione = this.capsItems[0].codice;
					}
					else {
						this.pratica.contratto_di_servizio.cap_fatturazione = null;
						this.selezioneCapInCorso = true;
					}
				})
				.finally(() => {
					this.isLoadingAllByComuneId = false;
				})
		},
		setFileChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		async getReport() {
			this.isLoadingReport = true;
			this.files.report = await this.getFile(this.pratica.contratto_di_servizio.path_report);
			this.files.report.changed = false;
			this.isLoadingReport = false;
		},
		aggiornaTipoPagamento(event) {
			this.pratica.contratto_di_servizio.tipo_contratto_di_servizio.tipo_pagamento = event.tipo_pagamento;
		},
		getCodiciSDI() {
			this.isLoadingCodiciSDI = true;
			
			axios.get('/api/codici-sdi')
				.then(response => {
					this.codiciSDI = response.data;
				})
				.finally(() => {
					this.isLoadingCodiciSDI = false;
				})
		},
		openAggiungiCodiceSDIDialog() {
			this.aggiungiCodiceSDIKey++;
			this.aggiungiCodiceSDIDialog = true;
		},
		handleCodiceSDIAggiunto(codice) {
			this.pratica.contratto_di_servizio.codice_univoco = codice.toString();
			this.searchCodiceUnivoco = codice.toString();
			this.getCodiciSDI();
		},
		validaPartitaIvaCodiceFiscaleAziendaleOPersonale(value) {
			if (!value) return true;
			
			// codice fiscale di persona inclusi i casi di omocodia
			const codiceFiscalePersonaleValido = CodiceFiscale.check(value);
			
			// valida vat europea + altri paesi)
			const vatValid = checkVAT(value, countries).isValid;
			
			const pIvaCFAzItaValido = this.validaPartitaIvaCodiceFiscaleAziendaleItaliano(value)
			
			if (!codiceFiscalePersonaleValido && !vatValid && !pIvaCFAzItaValido)
				return 'Inserisci una Partita IVA internazionale o un Codice Fiscale aziendale o personale italiano valido'
			else return true;
		}
	}
	
}
</script>

<style scoped>

</style>